import { useEffect, useState } from "react";
import { RefreshCw } from "lucide-react";
import { applyUpdate, onUpdateAvailable } from "../lib/swRegistration";

export default function UpdatePrompt() {
  const [showUpdate, setShowUpdate] = useState(false);

  useEffect(() => {
    onUpdateAvailable(() => setShowUpdate(true));
  }, []);

  if (!showUpdate) return null;

  return (
    <div
      className="fixed bottom-20 left-4 right-4 z-[9998] mx-auto max-w-sm rounded-2xl border border-[#514a3f]/20 bg-white shadow-xl p-4 flex items-center gap-3"
      data-testid="pwa-update-prompt"
    >
      <RefreshCw size={18} className="text-[#dfa625] shrink-0" />
      <div className="flex-1 min-w-0">
        <p className="text-sm font-medium text-[#514a3f]">A new version is available</p>
        <p className="text-xs text-[#514a3f]/60">Refresh to get the latest features</p>
      </div>
      <button
        onClick={() => { applyUpdate(); setShowUpdate(false); }}
        className="shrink-0 rounded-full bg-[#6b6751] text-[#f0ede4] px-4 py-1.5 text-xs font-semibold hover:bg-[#514a3f] transition-colors"
        data-testid="pwa-update-button"
      >
        Update
      </button>
    </div>
  );
}
